import "./index.css"
import { Suspense } from "react"
import ErrorBoundary from "./modules/error"

import AppProviders from "providers"
import Router from "modules/router"
import { BrowserRouter } from "react-router-dom"
import Loader from "components/loader"
import initI18n from "services/i18n"
import { ConfigProvider } from "antd"
import QueryErrorBoundary from "modules/error/query-error-boundary"

import frCA from "antd/es/locale/fr_CA"
import enUS from "antd/es/locale/en_US"
import { useTranslation } from "react-i18next"

initI18n()

function App() {
  const { i18n } = useTranslation()

  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: "var(--color-text-400)",
        },
      }}
      locale={i18n.language === "en" ? enUS : frCA}
    >
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          <ErrorBoundary>
            <QueryErrorBoundary isLayout={false}>
              <AppProviders>
                <Router />
              </AppProviders>
            </QueryErrorBoundary>
          </ErrorBoundary>
        </BrowserRouter>
      </Suspense>
    </ConfigProvider>
  )
}

export default App
